module.exports = __webpack_public_path__ + "static/media/metal-detector.ba73996f.png";